export default __webpack_public_path__ + "static/9001-da0972656b253aad9080ecef8f1922e1.webp";